// extracted by mini-css-extract-plugin
export default {"grid":"States_grid__aOqmK"};